const TTL_MS = 10 * 60 * 1000;

type CacheEnvelope<T> = {
  savedAt: number;
  data: T;
};

function readEnvelope<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const env = JSON.parse(raw) as CacheEnvelope<T>;
    if (Date.now() - env.savedAt > TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    return env.data;
  } catch {
    return null;
  }
}

function writeEnvelope<T>(key: string, data: T): void {
  try {
    const env: CacheEnvelope<T> = { savedAt: Date.now(), data };
    sessionStorage.setItem(key, JSON.stringify(env));
  } catch {
    /* quota or private mode */
  }
}

export function catalogCacheKey(shopIds: string[]): string {
  return `catalog:v1:${[...shopIds].sort().join(',')}`;
}

export function categoriesCacheKey(shopIds: string[]): string {
  return `categories:v3:${[...shopIds].sort().join(',')}`;
}

export function readCatalogCache<T>(shopIds: string[]): T | null {
  return readEnvelope<T>(catalogCacheKey(shopIds));
}

export function writeCatalogCache<T>(shopIds: string[], data: T): void {
  writeEnvelope(catalogCacheKey(shopIds), data);
}

export function readCategoriesCache<T>(shopIds: string[]): T | null {
  return readEnvelope<T>(categoriesCacheKey(shopIds));
}

export function writeCategoriesCache<T>(shopIds: string[], data: T): void {
  writeEnvelope(categoriesCacheKey(shopIds), data);
}

export function attributesCacheKey(shopIds: string[]): string {
  return `attributes:v1:${[...shopIds].sort().join(',')}`;
}

export function readAttributesCache<T>(shopIds: string[]): T | null {
  return readEnvelope<T>(attributesCacheKey(shopIds));
}

export function writeAttributesCache<T>(shopIds: string[], data: T): void {
  writeEnvelope(attributesCacheKey(shopIds), data);
}
